import { Injectable } from '@angular/core';
import { PatientStore } from '@modules/patient/state/patient-store';
import { RxModel } from '@shared/models/rx-models/interfaces/rx-model';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { Observable, combineLatest, merge } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PatientAppIframeCommunicationService } from './patient-app-iframe-communication.service';

@Injectable({
	providedIn: 'root'
})
export class PatientAppInitService {
	constructor(
		private readonly patientStore: PatientStore,
		private readonly shellQuery: ShellQuery,
		private readonly patientAppIframeCommunicationService: PatientAppIframeCommunicationService
	) {}

	get initializePatientAppStreams$(): Observable<void | MessageEvent<any>> {
		return merge(this.registerToPatientAppEvents$(), this.loadPatientFromRx$());
	}

	private registerToPatientAppEvents$(): Observable<MessageEvent> {
		return this.patientAppIframeCommunicationService.registerToPatientAppEvents();
	}

	private loadPatientFromRx$(): Observable<void> {
		return combineLatest({
			rx: this.shellQuery.rx$,
			clonedRx: this.shellQuery.clonedRx$,
			regulatoryDOBMask: this.shellQuery.regulatoryDOBMask$
		}).pipe(
			filter(
				(latest): latest is { rx: RxModel; clonedRx: RxModel; regulatoryDOBMask: string | undefined } =>
					!!latest.rx || !!latest.clonedRx
			),
			map(({ rx, clonedRx, regulatoryDOBMask }) => {
				const loadedRx = rx || clonedRx;

				this.patientStore.updatePatient(loadedRx.Patient, null, regulatoryDOBMask);
			})
		);
	}
}
